import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AutocompleteFunction } from '../../../../core/common/entities/autocompleteFunction.entity';
import { FormSelectOption } from '../../../entities/form-select-option.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormTypedValueListBaseComponent } from '../base-simple/form-typed-value-list-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormTypedValueListComplexBaseComponent } from '../base-complex/form-typed-value-list-complex-base.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';

@Component({
    selector: 'sh-form-typed-value-list',
    templateUrl: './form-typed-value-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormGroupComponent, NgIf, ShFormTypedValueListComplexBaseComponent, ReactiveFormsModule, ShFormTypedValueListBaseComponent, AsyncPipe]
})
export class ShFormTypedValueListComponent extends ShBaseFormComponent {
    @Input() types: FormSelectOption[] = [];
    @Input() typeLabel = '';
    @Input() typePlaceholderMsg = '';
    @Input() valueLabel = '';
    @Input() valuePlaceholderMsg = '';
    @Input() autocompleteFcts?: Record<string, AutocompleteFunction>;
}
